import { render, staticRenderFns } from "./DateTimePicker.vue?vue&type=template&id=5827e16d&"
import script from "./DateTimePicker.vue?vue&type=script&lang=js&"
export * from "./DateTimePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports